/* A section that floats over the one after it as a card that opens (data-rfhq-popover, put there by website_hq/templates/includes/rfhq/tokens.html from the section's Pop-over field).
   Its first card stays on view, as a button; a tap opens the others (a card on a laptop, a sheet on a phone), a tap anywhere else or Escape shuts them again. The corner, the glass, the sheet and
   the reduced-transparency fallback are rfhq_popover.css; this file only opens and shuts and says so to a screen reader. The cards may come from an app (App Records, drawn again every so often
   by rfhq_app_records.js, which says "rfhq:records-drawn") or be written on the page. No wording here: what the cards say is the page's and the app's. */
(function () {
	"use strict";

	function mount(section) {
		if (section.dataset.popMounted) return;
		section.dataset.popMounted = "1";
		let trigger = null;

		const grid = () => section.querySelector(".rfhq-records-wrapper, .rfhq-lg-grid");
		const isOpen = () => section.hasAttribute("data-open");
		function set(on) {
			if (on) section.setAttribute("data-open", ""); else section.removeAttribute("data-open");
			if (trigger) trigger.setAttribute("aria-expanded", on ? "true" : "false");
		}

		// The first card of the list is the button (again after the cards were drawn again; whether it is open stays as it was).
		function arrange() {
			const list = grid();
			const first = list && list.querySelector(":scope > .rfhq-record-cell, :scope > .rfhq-card");
			if (!first) { trigger = null; return; }
			if (!list.id) list.id = "rfhq-pop-" + Math.random().toString(36).slice(2, 8);
			trigger = first;
			trigger.setAttribute("role", "button");
			trigger.setAttribute("tabindex", "0");
			trigger.setAttribute("aria-haspopup", "true");
			trigger.setAttribute("aria-controls", list.id);
			trigger.setAttribute("aria-expanded", isOpen() ? "true" : "false");
		}

		section.addEventListener("click", (event) => {
			if (trigger && trigger.contains(event.target)) set(!isOpen());
		});
		section.addEventListener("keydown", (event) => {
			if (event.key === "Escape" && isOpen()) { set(false); if (trigger) trigger.focus(); return; }
			if (trigger && event.target === trigger && (event.key === "Enter" || event.key === " ")) { event.preventDefault(); set(!isOpen()); }
		});
		document.addEventListener("click", (event) => { if (isOpen() && !section.contains(event.target)) set(false); });
		section.addEventListener("rfhq:records-drawn", arrange);

		arrange();
	}

	function init() { document.querySelectorAll("[data-rfhq-popover]").forEach(mount); }
	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
